module.exports = {
  global: {
    status: {
      done: 'Already Completed',
      preview: 'Previewable',
      failed: 'Translation Failed',
      translation: 'Translation in progress...',
    },
    lang: {
      zh: 'Chinese',
      en: 'English',
      ja: 'Japanese',
    },
    down: {
      word: 'Download Word Document',
      pdf: 'Download PDF',
      preview: 'Preview',
      read: 'Preview',
    },
  },
  tabNav: {
    online: 'Translate Online',
    api: 'Translation API',
    personal: 'User Center',
  },
  my: {
    nav: {
      doc: 'My Documents',
      collection: 'My Favorites',
      history: 'History',
      translator: 'My Translations',
      vip: 'Become a VIP',
      personal: 'User Center',
    },
  },
  vip: {
    privileges: 'VIP Benefits',
    des: [
      'Unlimited document Translation',
      'Unlimited Web Translation',
      'VIP Logo',
      'Bigger Dictionary',
    ],
    full: 'VIP Top Up',
    exchange: 'Clouds Exchange',
    service: 'VIP Service Agreement',
    time: 'Valid until ',
    pay: 'Total amount payable',
    paySure: 'Confirm Top Up information',
    payPoint: 'Confirm to exchange Clouds to get VIP',
    sure: 'Confirm',
    cancel: 'Cancel',
    dealTitle: ' LingoCloud VIP User Agreement',
    PayOk: 'Confirm payment',
    PayOver: 'Payment Complete',
    PayError: 'Payment Failed',
    PayPointOk: 'Exchange complete',
    PayPointErr: 'Exchange failed',
    topUpSuccess: 'Top Up success',
    topUpError: 'Top Up error',
    payMentComplete: 'Whether the payment is complete ?',
    vipList: {
      pay: [
        '1 MONTH',
        '3 MONTHS',
        '6 MONTHS',
        'A YEAR',
      ],
      point: [
        '1 Day',
        '1 Week',
      ],
    },
  },
  doc: {
    nodata: "You haven't added any files yet",
    tips: 'Tips',
    delete: 'Delete',
    deleteSuccess: 'Deletion successful',
    deletefailed: 'Cancel The Deletion',
    sure: 'Confirm',
    cancel: 'Cancel',
  },
  translator: {
    nodata: "You haven't translated anything yet",
    like: 'Liked',
    nolike: 'Did not receive any likes yet',
  },
  history: {
    nodata: "You don't have a browsing history yet",
  },
  personal: {
    data: {
      tr: 'Translate ',
      like: 'Liked ',
      headshot: 'Profile picture',
      nickname: 'Nickname',
      upData: 'Update',
    },
    upData: {
      ok: 'Update success',
      error: 'Update failure',
    },
  },
  points: {
    details: '"Clouds" Explanation',
    what: 'What is "Clouds"',
    isWhat: '"Clouds" is a points system which rewards registered members for using LingoCloud. Clouds can be exchanged for a VIP membership and additional services such as Website Translation.',
    computations: 'Clouds Calculation Rule',
    add: 'Click to load more',
  },
  collection: {
    nodata: "You don't have any Favorites yet",
    alert: {
      message: 'Cancel Add to Favorites?',
      sure: 'Confirm',
      cancel: 'Cancel',
      error: 'Cancelling Add to Favorites failed',
    },
  },
  share: {
    openLink: 'Open original text',
    keptPrivate: 'To be kept private',
    sina: 'Sina Weibo',
    weixin: 'Scan on WeChat',
  },
  header: {
    home: 'Homepage',
    SignOut: 'Sign out',
    register: 'Login / Registration',
  },
  PayAgreement: {
    pange1: 'LINGOCLOUD FEE-PAYING USER MEMBERSHIP SERVICE AGREEMENT',
    pange2: 'IMPORTANT TIPS',
    pange3: 'You are welcome to use the LingoCloud membership (hereinafter referred to as the "paid member") service. To protect your rights and interests, please read this Service Agreement (hereinafter referred to as "this agreement") before using the paid membership service, especially the thickening part. Minors should be read in the presence of a legal guardian. Unless you have read and accepted all the terms of this agreement, you do not have the right to use paid membership services. Your purchase and / or use of the paid membership service shall be deemed to have been read and agreed to be bound by this agreement.',
    pange4: 'First, ACCEPTANCE AND AMENDMENT OF SERVICE AGREEMENTS',
    pange5: '1.1 The contents of this agreement include the text of the agreement, the various rules that have been published or may be published / updated by the beijing-based Chaechian Technology Co. Ltd. (hereinafter referred to as "Cheche technology") . All rules are an integral part of this agreement and have the same legal effect as the text of the agreement, the body of this agreement is in conflict with the aforesaid rules, the text of this agreement shall prevail. Unless otherwise expressly stated, you are bound by this agreement for the use of paid membership services.',
    pange6: '1.2 This agreement and the relevant terms of service shall be published on the relevant LingoCloud page if the business development needs to be revised. You may check the terms of the latest agreement. If you do not accept the amended clause, you may choose to terminate the use of the paid membership service after the colorful technology changes the above-mentioned clause. If you continue to use this service, you will be considered to have accepted the revised agreement.',
    pange7: 'Number two, definition',
    pange8: '2.1 FEE-PAYING MEMBER: refers to the network value-added service provided by Chaechian Technology, you may enjoy certain privileges or participate in activities under this agreement after becoming a paid member, subject to the provision of Choi Chor Technology. The ownership and operation rights of the paid members, as well as the right to formulate paid membership systems and activities, are owned by Cheche Technology, which has the power of interpretation within the limits prescribed by law',
    pange9: '2.2 "User" or "You" means an individual or a single entity that enjoys the services of a paid member provided by Choi Chor Technology.',
    pange10: 'Rule number three: the process of becoming a paid member',
    pange11: '3.1 If you wish to use a paid membership service, you need to Login your Choi Wan Account or register your Choi Wan Account and login. On the basis of the successful login of Choi Wan Account, application for the opening of a paid membership service. If you choose another third-party account to login the Lingocloud, you should ensure the stability, authenticity and availability of the third party account, if you are unable to Login your account due to third-party account reasons (such as the blocking of third-party accounts) , you should contact the company of the third party account. The cloud cloud account that you log into when you are using a paid member service is the only basis for confirming your identity.',
    pange12: '3.2 You can open a paid membership service by completing payment by means of payment approved by Choi Chor Technology in the open service interface. When you open a service, you should carefully check the account name, the service type and the length of service. The fees charged by Choi Chor Technology Will Not Be refunded if you cause an incorrect account, error opening service or length for personal reasons.',
    pange13: 'Article 4. Relevant provisions concerning the eligibility of a paid member',
    pange14: '4.1 The fee-paying membership service is limited to the application account and can not be transferred between different cloud accounts.',
    pange15: '4.2 If you take the initiative to cancel or terminate the paid membership during the period of validity of the paid member already in operation, you will not receive a refund of the membership fee.',
    pange16: '4.3 After the termination / termination of a paid membership, you no longer have a paid membership service.',
    pange17: 'Article 5: RULES FOR THE USE OF PAID MEMBERS',
    pange18: '5.1 Are you sure that you are a natural, legal or other organization with full civil capacity and full civil capacity, capable of taking sole responsibility for all acts in which you use the services of a paid member. If you do not possess the above-mentioned qualifications, the Chaechian technology shall have the right to recover from Your Guardian or other responsible party in accordance with the provisions of the law or the agreement of this agreement. If you are a natural person, you should provide real name, address, e-mail address, contact phone number, etc. to Choi Chor Technology. If you are a legal person or any other organization, you should provide the name, address, contact person, etc.',
    pange19: '5.2 You should keep the account number and password properly and be responsible for all activities and actions carried out by the account. It is prohibited to grant, borrow, lease, assign or sell the account. You are responsible for the proper custody, use and maintenance of your account number, account information and account password you have obtained in your LingoCloud. Choi Chek Chai Technology does not bear any responsibility for the leakage of your account password and loss due to improper custody, use and maintenance of your account.',
    pange20: '5.3 If you have committed one of the following acts, the Chaechian technology has the complete right to terminate the provision of paid membership services without informing you, and have the right to restrict, freeze or terminate the use of the cloud account associated with the service. Choi Chek Chai technology does not have to give any compensation and refund, resulting in the responsibility to be borne by you independently. Therefore, you shall be responsible for the full compensation for the losses caused by the technology or the third party in the Cheche District:',
    pange21: '(1) To obtain paid membership services for themselves or others for profit;',
    pange22: '(2) To lease, lend, sell, or otherwise use paid membership accounts to a third party;',
    pange23: '(3) Any content obtained through the payment of membership services will be used for purposes other than personal learning, research or appreciation;',
    pange24: '(4) Theft of another person`s cloud account for the registration or use of a paid member;',
    pange25: '(5) Access to paid membership services in any robot software, spider software, crawler software, screen-painting software or other informal means;',
    pange26: '(6) Access to paid membership services through improper means or in violation of the principle of good faith.',
    pange27: '5.4 In the event of any of the following circumstances, the CHAECHIĆA technology has the right to interrupt or terminate one or more or all of the services provided to you without notice to you, in accordance with the actual circumstances, choi Chek Chai technology does not need to give any compensation and refund. You shall be responsible for compensation in full if any loss is caused to Choi Chor technology or to a third party：',
    pange28: '(1) The personal information you provide is not true or is not consistent with the information at the time of registration and does not provide reasonable proof；',
    pange29: '(2) The legal instrument in force for the administration or judiciary of the state recognizes that you are guilty of an offence or a violation of your rights, or that Choi Chor Minh Technology is based on its own judgement, that your conduct is suspected of violating the contents of this agreement or the rules of use published from time to time by Chaechiaki, or are suspected to be in violation of the provisions of the laws and regulations；',
    pange30: '(3) Your actions interfere with the proper functioning of any part or function of the LingoCloud；',
    pange31: '(4) You carry out LingoCloud activities without the permission of Choi Chek Chor Technology Without the consent of Choi Chor Technology, including, but not limited to, the commercialisation of information obtained through Lingocloud, additional advertising, business content, links, etc；',
    pange32: '(5) Your personal information, publishing content and other violations of the laws and regulations of the state, contrary to social ethics, public order, infringement of the legitimate rights and interests of others, strong political color, causing any controversy, or contravenes the requirements of this agreement and Lingocloud;',
    pange33: '(6) You use your LingoCloud to commit any illegal activity.',
    pange34: 'Article 6. Declaration of Responsibility',
    pange35: '6.1 If you purchase / accept any goods or services provided by a third party business other than Chaecho technology in exercise of the rights set forth in this agreement, you should assert your rights to a third party merchant who sells / provides the goods or services, regardless of the technicality of the Checher district.',
    pange36: '6.2 You are fully liable for yourself and the guests you invite to participate in the activities of the LingoCloud organisation or use all the benefits and value-added services provided by the LingoCloud.',
    pange37: '6.3 Choi chek-ming technology is not liable for any loss or damage caused by the actions or omissions of a third party or force majeure, these include, but are not limited to, payment services, Internet access services, telecommunications sector communications line failures, communications technology issues, networks, computer glitches, systemic instability, and any infringement by third parties.',
    pange38: '6.4 You understand and agree that in the process of using paid membership services, risk factors such as force majeure may be encountered, leading to the interruption of the service. In the event of such a situation, Cheche technology promises to cooperate with the repair unit as soon as possible, but will not bear any losses caused to you and will not refund the membership fee.',
    pange39: 'Article 7. Other agreements',
    pange40: '7.1 Termination, interruption and termination of services: Choi Tsun Technology may choose to discontinue, discontinue and terminate the payment of membership services on the basis of its own business decisions, government actions, force majeure etc. If such a situation occurs, you will be notified in the form of a public notice by Choi Chor Technology, but will not bear any loss to you and will not refund the membership fee.',
    pange41: '7.2 Law and Dispute Resolution: This agreement applies the laws of the People`s Republic of China and excludes the application of all provisions of the law of conflict. In the event of a dispute, you and Chaecho technology have agreed to submit the dispute to the Chinese international economic and Trade Arbitration for Arbitration in accordance with its existing and effective arbitration rules. The arbitral award is final and binding on both parties. The cost of the arbitration shall be borne by the losing party.',
    pange42: '7.3 The non-exercise, timely exercise or full exercise of the rights in this agreement or in accordance with the provisions of the law shall not be considered to be a waiver of this right, nor shall it affect the future exercise of the right by the Checher district technology.',
    pange43: '7.4 If you have any questions about the content of this article, please send us an email to our customer service address: (xiaoyi@caiyunapp.com）',
    pange44: 'Beijing Chaeche District Ming Technology Co. Ltd',
    pange45: 'October 31,2017',
  },
  fanyi: {
    toPersonal: 'Access to Personal Centres',
    button: 'Translate',
    placeholder: 'Please enter the text to be translated',
    upMessage: 'Support docx, PDF format document translation',
    upbutton: 'Uploading (Beta)',
    copyButton: 'Copy',
    isFileArr: ['Uploading...', 'Translationing'],
    isCopyArr: ['copy', 'copied', 'copy error'],
    progress: 'Completed',
    pre_progress: 'Previewing Completed',
    error: 'Error',
    message: {
      format: 'Wrong file format, please select docx or PDF file',
      ts_error: 'File translation failed. Please try again',
      up_error: 'File upload failed. Please try again',
      up_fail: 'Failed to upload document',
      changePdf: 'Document translation conversion PDF preview failure',
      ts_fail: 'Translation failure of document translation',
      ts_no: 'The translation status of the document is incorrect. Please try again',
      size_a: 'Please choose less than  ',
      size_b: 'M documents',
      change_lang: 'Please choose translation language',
      ts_ok: 'Translation has been completed',
      xiaoyi_m: 'LingoCloud is working hard for you to translate the full text ',
    },
    _translate: [
      'Automatic Recognition',
      'Chinese » English',
      'English » Chinese',
      'Chinese » Japanese',
      'Japanese » Chinese',
    ],
    downAllDoc: 'Download full text',
  },
  read: {
    weixin: ['WeChat sweep: Share', 'In WeChat, click "find"', 'Code can be shared to friends circle'],
    over_buton: 'The translation is complete. Click to view the full text',
  },
  title: {
    all: 'LingoCloud - ',
    mine: 'Personal Centre',
    online: 'Online translation',
    doc: 'Document translation',
  },
  filebutton: {
    button: ['Uploading documents', 'In translation...'],
    text: ['Chinese  »  English', 'English  »  Chinese', 'Chinese  »  Japanese', 'Japanese  »  Chinese'],
    message: 'Support docx, PDF format document translation',
  },
  vipComponent: {
    pay: {
      friend: 'Invite  friends and download it for free',
      friend1: 'Invite ',
      friend2: ' friends and download it for free',
      money: 'Pay to download the document',
      money1: 'Pay ',
      money2: ' to download the document',
      money3: 'low ',
      money4: '',
      money5: 'RMB',
      vip: 'Become a VIP user for free downloads',
      free1: 'Free downloads（ ',
      free2: ' more left ）',
      free: 'Free Download (0 more left)',
      freeOver: 'Sorry! You have already used all of your free translations',
    },
    orderError: 'Order generation failed',
    helpError: 'Power Failure',
    downOK1: 'Your remaining number of free downloads is',
    downOK2: 'times',
    over: 'You are out of free experiences',
    userFree: 'Congratulations! Used an opportunity to download a free document',
    tips: 'You have already used up your VIP downloads for this month',
  },
}



//////////////////
// WEBPACK FOOTER
// ./static/lang/en.js
// module id = AQny
// module chunks = 1